import axios from 'axios';

export class CountryService {
  getCountries() {
    return axios.get('assets/data/countries.json').then((res) => res.data.data);
  }
}
